import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Backdrop, Button, CircularProgress, Container } from "@mui/material";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import GetAuth from "../../../GetAuth";
import { ref, child, get, getDatabase, set } from "firebase/database";
import ReactPlayer from "react-player";

const Scripts = () => {
	const [submitting, setSubmitting] = useState(false);
	const { register, handleSubmit, reset } = useForm({
		defaultValues: {
			quickPropertySearch: "",
		},
	});
	const [info, setInfo] = useState();
	const dbRef = ref(getDatabase(GetAuth()?.auth));
	const [load, setLoad] = useState();
	useEffect(() => {
		get(child(dbRef, "michelsonaristhyl")).then((snapshot) => {
			setLoad(snapshot.val());
			reset(snapshot.val()?.scripts);
			setInfo(snapshot.val()?.scripts);
		});
	}, [dbRef, reset, submitting]);
	const onSubmit = ({ quickPropertySearch }) => {
		setSubmitting(true);
		const data = {
			quickPropertySearch,
			submitTime: new Date().toLocaleString(),
		};
		set(child(dbRef, "michelsonaristhyl"), { ...load, scripts: data })
			.then(function (response) {
				setSubmitting(false);
				Swal.fire({
					icon: "success",
					title: "Successfully Updated",
					showConfirmButton: false,
					timer: 1500,
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	};

	return (
		<Container sx={{ pt: 1 }}>
			<Typography
				variant='h4'
				gutterBottom
				className='textColor'
				sx={{ fontWeight: "bold" }}>
				Welcome Video
			</Typography>
			<Typography sx={{ pb: 2 }} className='textColor'>
				Last changed in {info?.submitTime || "N/A"}
			</Typography>

			<form onSubmit={handleSubmit(onSubmit)} method='post'>
				<Grid container spacing={3} justifyContent='center'>
					<Grid item md={6} sm={6} xs={12}>
						<TextField
							required
							name='quickPropertySearch'
							label='Welcome Video Link'
							fullWidth
							InputLabelProps={{
								shrink: true,
							}}
							{...register("quickPropertySearch", { required: true })}
						/>
						<ReactPlayer
							className='borderColor react-player'
							width='100%'
							url={info?.quickPropertySearch}
							controls
						/>
					</Grid>

					<Grid item md={12} sm={12} xs={12}>
						<Button
							type='submit'
							variant='contained'
							sx={{
								mb: 2,
								px: 5,
								fontWeight: "bold",
								borderRadius: "25px",
							}}>
							Save
						</Button>
					</Grid>
				</Grid>
			</form>
			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={submitting || !info}>
				<CircularProgress color='inherit' />
			</Backdrop>
		</Container>
	);
};

export default Scripts;
